import type { IBatchStore } from './batch-store-types';
import { DeviceStatus } from '../../constants/DeviceStatus';

export const pumpHelpersMixin = {

  /**
   * Close pump
   *
   * @param pump
   * @param trackHold
   */
  closePump(this: IBatchStore, pump: any, trackHold = false): void {
    const isOpen = this.isOutputOn(pump.gatePNo);
    if (isOpen) {
      this.setOutput(pump.gatePNo, '0');

      if (trackHold && !this.trackedFeedPumps.find((id: any) => id === pump.id)) {
        this.trackedFeedPumps.push(pump.id);
      }
    }
  },

  /**
   * Hold pump
   *
   * @param pump
   */
  holdPump(this: IBatchStore, pump: any): void {
    this.resetMeter(pump.meterPNo);
    this.closePump(pump, true);

    const d = this.getDeviceStatus(pump.id);
    this.deviceStatus.set(pump.id, {
      ...d,
      status: DeviceStatus.HOLD,
    });
  },

  /**
   * Resume feed pump
   *
   * @param pumpId
   */
  resumeFeedPump(this: IBatchStore, pumpId: any): void {
    this.trackedFeedPumps = this.trackedFeedPumps.filter((id: any) => pumpId !== id);
  },

};
